module.exports = "/images/bg_everest11.jpg?dcf0937addec92a313eb3863acd264e1";